const binding = { modules: {}, dataActions: {} };

    (binding.modules['cip-channel-notification'] = {
        c: () => require('partner/modules/cip-channel-notification/cip-channel-notification.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'cip-channel-notification',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/cip-channel-notification'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|cip-channel-notification|cip-channel-notification'] = {
                c: () => require('partner/modules/cip-channel-notification/cip-channel-notification.view.tsx'),
                cn: '__local__-__local__-cip-channel-notification'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };